module.exports = __webpack_public_path__ + "img/SKWINKELNetActieGeschenkenA1BD39.d97dc53a.png";